'use client';

import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import { Link } from '@/i18n/routing';

export default function JobsError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations('Jobs');

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="flex min-h-[60vh] flex-col items-center justify-center gap-6 px-4 text-center">
      <p className="font-matter text-text-secondary text-[18px]">
        {t('unavailable')}
      </p>
      <div className="flex items-center gap-4">
        <button
          type="button"
          onClick={reset}
          className="brand-gradient-button font-matter cursor-pointer rounded-full px-6 py-3 text-[15px] font-medium"
        >
          {t('tryAgain')}
        </button>
        <Link
          href="/jobs"
          className="font-matter text-text-secondary text-[15px]"
        >
          {t('backToJobs')}
        </Link>
      </div>
    </main>
  );
}
